// A modern alternative to CSS resets
import 'normalize.css/normalize.css';
// animate.css
import 'animate.css';
import sensorsDataAnalytic201505 from 'sa-sdk-javascript';

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import dayjs from 'dayjs';

// sentry错误监控
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import packageJson from '../package.json';

// Element-Ui
import './components/elementUi';

// 全局注册
import './registerGlobal/index';
// 全局样式
import './styles/index.scss';

// antd
// import './components/antDesign';

// filters
import './filters';
// utils
import { sonarUrlUtils } from './utils';

// directives
import './directives';

// 根组件
import App from './App.vue';
import router from './router';
import store from './store';
import saveScrollPosition from './mixins/saveScrollPosition';

// 图标(svg)
import './assets/icons';
// 权限控制
import './permission';
// 国际化
import i18nConfig from './locale';
// 错误日志
// require('@klicen/catcherror').default({
//     app: 'gaia-saas',
//     env: process.env.NODE_ENV === 'development' ? 'dev' : '',
//     vue: Vue,
// });

Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'zh-CN', // 语言标识
    messages: i18nConfig,
});

// 事件总线
const Bus = new Vue();

// 缓存页签滚动条位置
Vue.mixin(saveScrollPosition);

Vue.prototype.$dayjs = dayjs;
Vue.prototype.$bus = Bus;
Vue.config.productionTip = false;

// 开启sentry错误监控
if (process.env.NODE_ENV === 'production') {
    let dsn = '';
    const { origin } = location;
    if (origin.includes('gaiaxyt.test.iklicen.com') || origin.includes('gaiaxyt.test1.iklicen.com')) {
        // 测试环境
        dsn = 'http://49c99fcf7986449b8c0847f33d96582b@sentry-test.iklicen.com/7';
    }
    if (origin.includes('gaiaxyt.klicen.com')) {
        // 线上环境
        dsn = 'https://544990a476f846aea4d4776f296daf6f@sentry.klicen.com/4';
    }
    Sentry.init({
        Vue,
        dsn,
        release: packageJson.version, // 版本控制
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//],
            }),
        ],
        tracesSampleRate: 1.0,
    });
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');

const { host } = window.location;
// let url = 'http://ut.klicen.com/logcollect/collect/client';
// if (host.includes('dvo')) url = 'http://galaxy.dev.iklicen.com/logcollect/collect/client';
// if (host.includes('test')) url = 'http://galaxy.test.iklicen.com/logcollect/collect/client';
// if (host.includes('pre')) url = 'http://galaxy2.pre.klicen.com/logcollect/collect/client';
// if (host.includes('uat')) url = 'http://galaxy.uat.iklicen.com/logcollect/collect/client';
// 线上
let url = sonarUrlUtils.sensorsUrl;
if (host.includes('dvo')) url = sonarUrlUtils.sensorsDvoUrl;
if (host.includes('test')) url = sonarUrlUtils.sensorsTestUrl;
if (host.includes('pre')) url = sonarUrlUtils.sensorsPreUrl;
if (host.includes('uat')) url = sonarUrlUtils.sensorsUatUrl;

sensorsDataAnalytic201505.init({
    server_url: `${url}?app_name=xytsaas`,
    // server_url: 'http://galaxy.dev.iklicen.com/logcollect/collect/client?app_name=xytsaas',
    use_client_time: true,
});
